import React, {Component} from 'react';

import styled from 'styled-components';
import { useHistory } from "react-router-dom";
import QBELogo from '../../assets/QBE_logo.svg';
import BMLogo from '../../assets/BmLogo.png';
import GNMLogo from '../../assets/GnM_logo.png';
import ArrowIcon from '../../assets/Arrow.png';
import XmarkIcon from '../../assets/Xmark.png';
import Surety from '../../assets/Surety.svg';
import {_getSite, _hideModal, _showModal} from "../../store/system/service";
import {connect} from "react-redux";
import {_saveForLater, _gaPushEvent, _gaPushData} from "../../utils/utility";
import {gridCell, mdDown, mdDownN, mdUp, mdUpN} from "../../ui/common";
import Stepper from "../../ui/components/progress/stepper";
import SaveButton from '../../assets/Save_White.svg';
import {css} from 'styled-components';
import MLALogo from "../../assets/MLA_logo.png";

const LogoGroup1Style = styled.div`
    display: flex;
    position: absolute;
    left: 152px;
    height: 112px;
    width: 333px;
    @media (max-width: 1400px) {
        margin-left: 20px;
        left: auto;
        position: relative;
    }
    @media (max-width: 1086px) {
        display: none;
    }
`;
const MobileLogoGroup1Style = styled.div`
    position: absolute;
    left: 152px;
    height: 112px;
    width: 333px;
     display: none;
    @media (max-width: 1086px) {
        // background: green;
        width:auto;
        height: auto;
        display: flex;
        position: relative;
        top: auto;
        left: auto;
        flex-grow:1;
        margin-left: 13.05px;
    }
`;

const LogoGroup2Style = styled.div`
    top: 43px;
    height: 27px;
    width: 160px;
    position: absolute;
    margin: 0;
    @media (max-width: 1086px) {
        position: relative;
        top: auto;
        left: auto;
    }
`;

const GnmLogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 1px;
    height: 26px;
    width: 54px;
`;

const BmLogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    top: -10px;
    height: 46px;
    width: 54px;
`;
const MlaLogoStyle = styled.img`
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 1px;
    height: 26px;
    width: auto;
`;

const PathStyle = styled.div`
    display: inline-block;
    position: absolute;
    left: 67px;
    &.mla{
        left: 42px;
    }
    box-sizing: border-box;
    height: 26.73px;
    width: 1px;
    border: 1px solid #FFFFFF;
    opacity: 0.48;
`;

const QbeLogoStyle = styled.div`
    display: inline-block;
    position: absolute;
    top: 2px;
    left: 82px;
    &.mla{
        left: 50px;
    }
    height: 22px;
    width: 78px;
    background-image: url(${QBELogo}); 
`;


const QuoteHeaderStyle = styled.div`
    height: 112px;
    width: 1440px;
    position: absolute;
    position: fixed;
    z-index:3;
    margin: 0 auto;
    // left: 0px;
    background-color: #14284B;
    @media (max-width: 1400px) {
        width: 100vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        
    }
    
   @media (max-width: 1086px) {
        height: 105px;
        padding-left: 16px;
        padding-right: 16px;
        position: relative;
        position: fixed;
        width: 100vw;
        left: auto;    
        display: -ms-grid;
        -ms-grid-columns: 1fr;
        -ms-grid-rows: 1fr 1fr;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 0px 0px;
        grid-template-areas: "control" "stepper";
        
    }
`;

const StyledStepper = styled(Stepper)`
    @media (max-width: 1400px) {
        position: relative;
    }
    @media (max-width: 1086px) {
        ${gridCell({column: 1, row: 2})}
    }

`;


const CmdGroupStyle = styled.div`
    top: 0px;
    height: 112px;
    width: 196px;
    position: absolute;
    margin: 0;
    left: 1098px;
    @media (max-width: 1400px) {
        display: flex;
        flex-direction: row;
        position: relative;
        right:0;
        left: auto;
        width: auto;
    }
    @media (max-width: 1086px) {
        height:50px;
        grid-area: control;
        position: relative;
        top: auto;
        left: auto;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        -ms-grid-row: 1;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 1;
    }
`;

const DivideBar1Style = styled.div`
    position: absolute;
    left: 0px;
    height: 112px;
    width: 2px;
    margin: 0;
    background-color: rgba(0, 193, 204, 0.2);
    ${({history, hideBtn}) => {
        if (hideBtn) {
            return css`
                display: none;
            `;
        } 
        
        if (!(history?.location?.pathname?.indexOf("/application") != -1
            || history?.location?.pathname?.indexOf("/payment") != -1
            || history?.location?.pathname?.indexOf("/quote/summary") != -1)) {
            return css`
                display: none;
              `;
        } 
    }}
    overflow: hidden;
    @media (max-width: 1086px) {
         display: none;
    }
`;

const DivideBar2Style = styled.div`
    position: absolute;
    left: 114px;
    height: 112px;
    width: 2px;
    margin: 0;
    background-color: rgba(0, 193, 204, 0.2);
    display: ${({hideBtn}) => hideBtn ? 'none' : 'inline'};
    overflow: hidden;
    @media (max-width: 1086px) {
        
        display: none;
    }
`;

const DivideBar3Style = styled.div`
    position: absolute;
    left: 228px;
    height: 112px;
    width: 2px;
    margin: 0;
    background-color: rgba(0, 193, 204, 0.2);
    overflow: hidden;
    @media (max-width: 1086px) {
        
        display: none;
    }
`;

const ArrowSectionStyle = styled.div`
    height: 112px;
    width: 109px;
    position: absolute;
    margin: 0;
    border-left: 2px solid rgba(0,193,204,0.2);
    
    ${({history, hideBtn}) => {
        if (hideBtn||history?.location?.pathname?.indexOf("/finish") != -1) {
            return css`
                    display: none;
                `;
        } 
        
        if (!(history?.location?.pathname?.indexOf("/application") != -1
            || history?.location?.pathname?.indexOf("/payment") != -1
            || history?.location?.pathname?.indexOf("/quote/summary") != -1)) {
            return css`
                    left: 112px;
                  `;
        }
    }}
    @media (max-width: 1400px) {
        position: relative;
        ${({history, hideBtn}) => {
            if (hideBtn||history?.location?.pathname?.indexOf("/finish") != -1) {
                return css`
                display: none;
                `;
            }
            
            if (!(history?.location?.pathname?.indexOf("/application") != -1
            || history?.location?.pathname?.indexOf("/payment") != -1
            || history?.location?.pathname?.indexOf("/quote/summary") != -1)) {
                return css`
                left: auto;
                `;
            }
        }}
    }
    @media (max-width: 1086px) {
        position: relative;
        border: none;
        top: auto;
        left: auto;
        width: auto;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        ${({history, hideBtn}) => {
            if (hideBtn||history?.location?.pathname?.indexOf("/finish") != -1) {
                return css`
                display: none;
                `;
            }
        
        }}
    }
`;

const ArrowStyle = styled.img`
    top: 48px;
    height: 16px;
    width: 27px;
    position: absolute;
    margin: 0;
    left: 45px;
    -ms-transform: rotate(-270deg);
    -webkit-transform: rotate(-270deg);
    transform: rotate(-270deg);
    @media (max-width: 1086px) {
        position: relative;
        top: auto;
        left: auto;
        height: 10.83px;
        width: 17.89px;
    }
`;

const SaveButtonSectionStyle = styled.div`
    height: 112px;
    width: 109px;
    position: absolute;
    margin: 0;
    left: 112px; 
    cursor: pointer;
    border-left: 2px solid rgba(0,193,204,0.2);
    ${({history, hideBtn}) => {
        if (hideBtn) {
        return css`
                display: none;
            `;
        } 
        
        if (!(history?.location?.pathname?.indexOf("/application") != -1
            || history?.location?.pathname?.indexOf("/payment") != -1
            || history?.location?.pathname?.indexOf("/quote/summary") != -1)) {
            return css`
                display: none;
              `;
        } 
    }}
    @media (max-width: 1400px) {
        left: auto;
        position: relative!important;
         ${props=>!props.mobileShow?'display: none;':''}
    }
    @media (max-width: 1086px) {
        margin-left: 23px;
        border: none;
        position: relative;
        top: auto;
        left: auto;
        width: auto;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        
        ${({history, hideBtn}) => {
            if (hideBtn) {
                return css`
                        display: none;
                    `;
            }
        
            if (!(history?.location?.pathname?.indexOf("/application") != -1
                || history?.location?.pathname?.indexOf("/payment") != -1
                || history?.location?.pathname?.indexOf("/quote/summary") != -1)) {
                return css`
                        display: none;
                      `;
            }
        }}
        ${props=>!props.mobileShow?'display: none;':''}
    }
   
`;

const SaveButtonStyle = styled.img`
    top: 43px;
    position: relative;
    margin: 0;
    left: 45px;
    @media (max-width: 1086px) {
        position: relative;
        top: auto;
        left: auto;
        width:17px;
        height:17px;
    }
`;

const XmarkSectionStyle = styled.div`
    height: 112px;
    width: 111px;
    position: absolute;
    margin: 0;
    left: 229px;
    border-left: 2px solid rgba(0,193,204,0.2);
    @media (max-width: 1400px) {
        left: auto;
        position: relative;
        
    }
    @media (max-width: 1086px) {
        margin-left: 23px;
       
        border: none;
        position: relative;
        top: auto;
        left: auto;
        width: auto;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
`;

const XmarkStyle = styled.img`
    top: 42px;
    height: 28px;
    width: 28px;
    position: absolute;
    margin: 0;
    left: 42px;
    @media (max-width: 1086px) {
        position: relative;
        top: auto;
        left: auto;
        width:17px;
        height:17px;
    }
`;

const steps = [
    {
        id: '0',
        name: 'Welcome',
    },
    {
        id: '1',
        name: 'Quote',
    },
    {
        id: '2',
        name: 'Apply',
    },
    {
        id: '3',
        name: 'Pay',
    },
    {
        id: '4',
        name: 'Insured',
    },
    {
        id: '5',
        name: 'Complete',
    }
];

const Header = (props) => {

    const history = useHistory();

    const back = (prevPage) => {
        // Google Analytics
        _gaPushEvent('back');
        if(history.location.pathname.indexOf("/application/confirm") != -1){
            _gaPushEvent('applyback');
        } else if(history.location.pathname.indexOf("/quote/review") != -1){
            _gaPushEvent('quickquoteback');
        } else if(history.location.pathname.indexOf("/quote/product") != -1){
            _gaPushEvent('selectbiztypeback');
        } else if(history.location.pathname.indexOf("/quote/size") != -1){
            _gaPushEvent('quotepageback');
        } else if(history.location.pathname.indexOf("/payment") != -1){
            _gaPushEvent('payback');
        }

        if (!prevPage){
            history.goBack();
        } else {
            history.push((props.site ? "/" + props.site : "") + prevPage);
        }
    }

    const close = () => {
        let additionalActions = {};

        if(history.location.pathname.indexOf("/application") != -1
            || history.location.pathname.indexOf("/payment") != -1
            || history.location.pathname.indexOf("/quote/summary") != -1){
            additionalActions = {
                secondaryAction: {
                    label: 'Save this form',
                    onClick: () => props.saveForLater({
                        history: history,
                        location: history.location,
                        site: props.site
                    })
                },
                content: (<div style={{marginTop: '44px'}}>You will lose your work if you leave</div>),
                title: (<div style={{marginTop: '28px'}}>Are you sure that you want to close this form?</div>)
            }
        } else {
            additionalActions = {
                title: (<div style={{marginTop: '50px'}}>Are you sure that you want to close this form?</div>)
            }
        }

        _gaPushEvent('close');

        props.showModals(
            {
                icon: Surety,
                primaryAction: {
                    label: 'Yes',
                    onClick: closeConfirm
                },
                ...additionalActions
            }
        )

        _gaPushData({
            event: 'vpageview',
            pageStep: 'closeform',
            vPath: '/closeform'
        });
    }

    const closeConfirm = () => {
        console.log('path ' + window.location.pathname);
        _gaPushEvent('closeformyes');
        let path = window.location.pathname;
        if (props.site) {
            path = path.substring(0, path.indexOf(props.site) + props.site.toString().length)
        }
        else {
            path = path.substring(0, path.indexOf("/", 1));
        }
        localStorage.clear();
        window.location.href = path;
    }
    const getLogoGroup = site =>{
        let result = null
        switch (site){
            case 'bm':
                result =
                    <LogoGroup2Style>
                        <BmLogoStyle src={BMLogo}/>
                        <PathStyle/>
                        <QbeLogoStyle/>
                    </LogoGroup2Style>
                break
            case 'mla':
                result =
                    <LogoGroup2Style>
                        <MlaLogoStyle src={MLALogo}/>
                        <PathStyle className={'mla'}/>
                        <QbeLogoStyle className={'mla'}/>
                    </LogoGroup2Style>
                    // <LandingLogoGroup2Style>
                    //     <LandingMLALogoStyle src={MLALogo}/>
                    //     <LandingPathStyle left={'left: 82px;'} onClick={selectPath}/>
                    //     <LandingQbeLogoStyle  left={'left: 92px;'}  onClick={qbeLogoClick}/>
                    // </LandingLogoGroup2Style>
                break
            case 'gnm':
            default:
                result =
                    <LogoGroup2Style>
                        <GnmLogoStyle src={GNMLogo}/>
                        <PathStyle/>
                        <QbeLogoStyle/>
                    </LogoGroup2Style>

        }
        return result
    }
    return (
        <QuoteHeaderStyle id="QuoteHeader">
            <LogoGroup1Style id="logo" hideM="true">
                {
                    getLogoGroup(props.site)
                }
            </LogoGroup1Style>
            <StyledStepper steps={ steps } activeStep={ props.step } />

            <CmdGroupStyle>
                <ArrowSectionStyle hideBtn={props.hideBackBtn} history={history} onClick={() => back(props.prevPage)}>
                    <ArrowStyle src={ArrowIcon}/>
                </ArrowSectionStyle>
                <SaveButtonSectionStyle hideBtn={props.hideBackBtn} history={history}
                                        onClick={() => props.saveForLater({
                                            history: history,
                                            location: history.location,
                                            site: props.site
                                        })}>
                    <SaveButtonStyle src={SaveButton}/>
                </SaveButtonSectionStyle>
                <MobileLogoGroup1Style id="logo"  hide="true">
                    {
                        getLogoGroup(props.site)
                    }
                </MobileLogoGroup1Style>
                <SaveButtonSectionStyle mobileShow={"true"} hideBtn={props.hideBackBtn} history={history}
                                        onClick={() => props.saveForLater({
                                            history: history,
                                            location: history.location,
                                            site: props.site
                                        })}>
                    <SaveButtonStyle src={SaveButton}/>
                </SaveButtonSectionStyle>
                <XmarkSectionStyle onClick={close}>
                    <XmarkStyle src={XmarkIcon}/>
                </XmarkSectionStyle>
            </CmdGroupStyle>

        </QuoteHeaderStyle>

    );
}

const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = {
    showModals: _showModal,
    hideModal: _hideModal,
    saveForLater: _saveForLater
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
